import { IUser } from 'types/user.types'
import { DROPDOWN } from 'locales/locales'

const LANGUAGE = navigator.language.split('-')[0]

export const SCROLL_THRESHOLD = -5
export const MOBILE_WIDTH = 1182
export const MOBILE_DEVICE_WIDTH = 575
export const STORAGE_KEY = 'this is secretly key'
export const MESSAGE_DATE_FORMAT = 'HH:mm'
export const TAG_IMG_NAME = 'IMG'
export const TAG_IMG_VIDEO = 'VIDEO'
export const CONFERENCE_TYPE_VIDEO = 'video'

export const MESSAGES_PER_PAGE = 20

export const CONFERENCE_BLANK_DIMENSIONS = 'top=50,left=242,width=1200,height=800'

//SIDE PANEL TYPES
export const SIDE_PANEL_PIN = 'Pin'
export const SIDE_PANEL_THREAD = 'Thread'
export const SIDE_PANEL_SEARCH = 'Search'
export const SIDE_PANEL_READERS = 'Reads'

//USER MANAGEMENT
export const SUPER_ADMIN = 'SUPER_ADMIN'
export const SYSTEM_GUEST = 'SYSTEM_GUEST'
export const SYSTEM_ADMIN = 'SYSTEM_ADMIN'


export const NOTIFICATION_LANGUAGES = [
  { title: DROPDOWN.TURKISH, value: 'tr' },
  { title: DROPDOWN.ENGLISH, value: 'en' },
  { title: DROPDOWN.ARABIC, value: 'ar' },
]

export const LDAP_SYNC_TIME_DATA = [
  { title: 'Hour', value: 'hour' },
  { title: 'Day', value: 'day' },
  { title: 'Month', value: 'month' },
  { title: 'Year', value: 'year' },
]

export const ON = ' on '

// FILE UPLOAD
export const FILE_SIZE_ERROR_CODE = 'file-too-large'
export const FILE_COUNT_ERROR_CODE = 'too-many-files'
export const FILE_INVALID_TYPE_ERROR_CODE = 'file-invalid-type'
export const MB = 1000000
export const GB = MB * 1024
export const MAX_FILE_NUMBER = 5


export const XLSX_TYPE = ['application/vnd.ms-excel','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']
export const PPTX_TYPE = ['application/vnd.openxmlformats-officedocument.presentationml.presentation','application/vnd.ms-powerpoint']
export const DOCX_TYPE = ['application/vnd.openxmlformats-officedocument.wordprocessingml.document','application/msword']
export const PDF_TYPE = ['application/pdf']
export const ZIP_TYPE = [
  'application/zip',
  'application/x-zip-compressed',
]
export const RAR_TYPE = [
  'application/vnd.rar',
  'application/x-compressed',
  'application/x-rar-compressed',
]
export const TXT_TYPE = ['text/plain']
export const CSV_TYPE = ['text/csv']

export const POST_SUPPORTED_FILES_TYPES = {
  'application/vnd.rar': ['.rar'],
  'application/zip': ['.zip'],
  'application/pdf': ['.pdf'],
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
  'application/vnd.ms-excel': ['.xls'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/msword': ['.doc'],
  'application/vnd.ms-powerpoint': ['.ppt'],
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
  'text/plain': ['.txt'],
  'text/csv': ['.csv'],
}

export const POST_SUPPORTED_IMAGES_TYPES = {
  'image/jpeg': ['.jpeg'],
  'image/png': ['.png'],
  'image/jpg': ['.jpg'],
}

export const POST_SUPPORTED_VIDEO_TYPES = {
  'video/quicktime': ['.mov'],
  'video/mp4': ['.mp4'],
  'video/x-msvideo': ['.avi'],
  'video/x-flv': ['.flv'],
  'video/x-matroska': ['.mkv'],
  'video/webm': ['.webm'],
}

export const SUPPORTED_FILE_TYPES = [
  {
    name: 'IMAGE_EXTENSIONS',
    extensions: [
      { name: '.png', value: 'image/png' },
      { name: '.jpeg', value: 'image/jpeg' },
      { name: '.jpg', value: 'image/jpg' },
    ],
  },
  {
    name: 'VIDEO_EXTENSIONS',
    extensions: [
      { name: '.mov', value: 'video/quicktime' },
      { name: '.mp4', value: 'video/mp4' },
      { name: '.avi', value: 'video/x-msvideo' },
      { name: '.flv', value: 'video/x-flv' },
      { name: '.mkv', value: 'video/x-matroska' },
      { name: '.webm', value: 'video/webm' },
    ],
  },
  {
    name: 'AUDIO_EXTENSIONS',
    extensions: [
      { name: '.aac', value: 'audio/aac' },
      { name: '.mp3', value: 'audio/mpeg' },
    ],
  },
  {
    name: 'TEXT_EXTENSIONS',
    extensions: [
      { name: '.txt', value: 'text/plain' },
      { name: '.csv', value: 'text/csv' },
    ],
  },
  {
    name: 'ARCHIVE_EXTENSIONS',
    extensions: [
      { name: '.zip', value: 'application/zip' },
      { name: '.rar', value: 'application/vnd.rar' },
    ],
  },
  {
    name: 'PDF_EXTENSION',
    extensions: [{ name: '.pdf', value: 'application/pdf' }],
  },
  {
    name: 'MICROSOFT_EXCEL_EXTENSIONS',
    extensions: [
      {
        name: '.xlsx',
        value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      },
      {
        name: '.xls',
        value: 'application/vnd.ms-excel',
      },
    ],
  },
  {
    name: 'MICROSOFT_WORD_EXTENSIONS',
    extensions: [
      {
        name: '.docx',
        value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      },
      { name: '.doc', value: 'application/msword' },
    ],
  },
  {
    name: 'MICROSOFT_POWERPOINT_EXTENSIONS',
    extensions: [
      {
        name: '.pptx',
        value: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
      },
      { name: '.ppt', value: 'application/vnd.ms-powerpoint' },
    ],
  },
]

export const MAX_FILE_NUMBER_ERROR =
  'Uploads limited to 10 files maximum. Please use additional messages for more files.!'

// OTR
export const OTR_REQUESTED_TEXT = (roomOwner: string, users?: IUser[]) =>
  LANGUAGE === 'en'
    ? `${roomOwner} wants to start Off The Record chat with ${
        users && users.length > 1 ? users.map((u) => u.fullname).join(', ') + ' and ' : ''
      } you. Do you want to join?`
    : `${roomOwner} sizle ${
        users && users.length > 1 ? ', ' + users.map((u) => u.fullname).join(', ') + ' ile ' : ''
      } OTR oluşturmak istiyor. Katılmak istiyor musunuz?`

// TIME
export const SECOND = 1000
export const MINUTE = 60 * SECOND
export const HOUR = 60 * MINUTE
export const DAY = 24 * HOUR
export const WEEK = 7 * DAY
export const MONTH = 30 * DAY

// SERVICE WORKER
export const DELETE_OTR = 'DELETE_OTR'
export const LOGOUT = 'LOGOUT'
export const LOGIN = 'LOGIN'
export const clientChannel = new BroadcastChannel('client')
export const notificationChannel = new BroadcastChannel('notification')
export const commentChannel = new BroadcastChannel('news-feed-comment')

// INVITE
export const PROCESSING_INVITE_TEXT = 'Processing invitation, please wait...'

export const RESEND_INVITE_DESCRIPTION = 'Are you sure you want to send invite to user again?'
export const CONFIRM_RESEND_INVITE = 'Confirm Resend Invite to User?'

export const POST_DATE_FORMATS = {
  POSTED_TODAY: 'HH:mm',
  POSTED_YESTERDAY: 'HH:mm',
  POSTED_AT_LEAST_TWO_DAYS_AGO: 'LLL',
}

export const DeviceShareOptions = [
  { title: DROPDOWN.UNRESTIRECTE, value: 0 },
  { title: DROPDOWN.ASK_ADMINISTATOR, value: 1 },
  { title: DROPDOWN.ADMINISTATOR_INITIATES, value: 2 },
]
export const RepeadDayOptions = [
  { title: DROPDOWN.MONDAY, value: 1 },
  { title: DROPDOWN.TUESDAY, value: 2 },
  { title: DROPDOWN.WEDNESDAY, value: 4 },
  { title: DROPDOWN.THURSDAY, value: 8 },
  { title: DROPDOWN.FRIDAY, value: 16 },
  { title: DROPDOWN.SATURDAY, value: 32 },
  { title: DROPDOWN.SUNDAY, value: 64 },
  { title: DROPDOWN.WEEKDAY, value: 128 },
  { title: DROPDOWN.WEEKEND, value: 256 },
  { title: DROPDOWN.EVERYDAY, value: 512 },
]

export const DATES_IN_MINUTES = {
  HOUR: 60,
  get DAY() {
    return this.HOUR * 24
  },
  get WEEK() {
    return this.DAY * 7
  },
  get MONTH() {
    return this.DAY * 30
  },
  get YEAR() {
    return this.MONTH * 12
  },
}

export const CHANNEL_MEMBER_LIMIT = 250
export const GM_ROOM_MEMBER_LIMIT = 8
